import { Chip } from "@mui/material";
import { BankAccountStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const VERIFICATION_STATUS_TO_COLOR = {
  [BankAccountStatus.Active]: undefined,
  [BankAccountStatus.Inactive]: undefined,
  [BankAccountStatus.Rejected]: "error.main",
  [BankAccountStatus.Restricted]: "warning.dark",
  [BankAccountStatus.AwaitingVerification]: "warning.dark",
  [BankAccountStatus.PreApproved]: "warning.dark",
} as const satisfies Record<BankAccountStatus, string | undefined>;

type Props = { verificationStatus: BankAccountStatus };

export const VerificationStatusChip = ({ verificationStatus }: Props) => {
  const { t } = useResource();

  return (
    <Chip
      component="span"
      size="small"
      variant="outlined"
      sx={{
        borderWidth: "0.5px",
        fontWeight: 300,
        color: VERIFICATION_STATUS_TO_COLOR[verificationStatus],
        borderColor: VERIFICATION_STATUS_TO_COLOR[verificationStatus],
      }}
      label={t(Resources.BankAccounts.VerificationStatus[verificationStatus])}
    />
  );
};
